import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./about.scss";
// Components
import TeamBox from './teamBox';
import TeamInfo from "./teamInfo";
import Title from "../ui-components/title/title";
// Assets
import Person01 from "../../assets/about/person01.png";
import Person02 from "../../assets/about/amber.png";

const about = () => (
  <div id="about">
    <div className="wrapper">
      <Title title="ABOUT ME." />
      <p className="font12">
		I am originally from Western Australia. Prior to settling in sunny California I lived in Australia, Canada and England.
                <br></br>I love going back to Australia to catch up with friends and family.
      </p>
      <Row>
        <Col md={12} lg={4}>
          <TeamBox avatar={Person01} name="Peter Forward" job="App Developer" />
        </Col>
        <Col md={12} lg={4}>
          <TeamBox avatar={Person02} name="Amber" job="Trusted Companion" />
        </Col>
        <Col md={12} lg={4}>
          <TeamInfo />
        </Col>
      </Row>
    </div>
  </div>
);

export default about;
